import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { LorenBaseEntityCrudFeatureDirective } from "../../../../shared/base-components/loren-base-entity-crud-feature/loren-base-entity-crud-feature.directive";
import { LorenGroupResolverConstant } from "../../resolvers/constants/loren-group-resolver.constant";
import { LorenDetailsOutletService } from "../../../../shared/services/loren-details-outlet-service/loren-details-outlet.service";
import { GroupItemModel } from "../../../../shared/modules/loren-hierarchy-selector/group.interface";

@Component({
    selector: "loren-groups-all",
    templateUrl: "./loren-groups-all.component.html",
    styleUrls: ["./loren-groups-all.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenGroupsAllComponent
  extends LorenBaseEntityCrudFeatureDirective<GroupItemModel>
  implements OnInit, OnDestroy
{
  protected detailsOutletService = inject(LorenDetailsOutletService);

  public isHandset: boolean;
  constructor() {
    super(LorenGroupResolverConstant.GROUPS);
  }

  ngOnDestroy() {
    this.detailsOutletService.toggleState(false);
  }
}
